import React, { useContext } from 'react';
import { useSelector } from 'react-redux';
import { styled } from '@linaria/react';
import { HotelCardContext } from 'components/HotelCardContext';
import placeHolderImage from 'images/placeholder-hotel-image.svg';
import { getHotel } from 'modules/sapiSearch/selectors';
import { toggle } from 'opticks';
import { imageProvider } from 'utils/imageProvider';
import { SelectedElement } from 'utils/selectedElement';
import { Box } from '@daedalus/atlas/helpers/Box';
import { SIZES } from '@daedalus/atlas/Image';
import { Image } from '@daedalus/atlas/Image';
import { useBrand } from '@daedalus/core/src/_web/brand/hooks/useBrand';
import { getDevicePixelRatio } from '@daedalus/core/src/_web/utils/browser/getDevicePixelRatio';
import { GALLERY_WIDTH as GALLERY_WIDTH_EXPERIMENTAL } from '../ExperimentalNoOffersCard/constants';
import { GALLERY_WIDTH } from '../HotelCardLayout/HotelCardLayout';
import { GalleryLoading } from './GalleryLoading';
const LAZYLOAD_PLACEHOLDER_HEIGHT = 160;
const GalleryImage = /*#__PURE__*/styled('div')({
  name: "GalleryImage",
  class: "gvdec68",
  propsAsIs: false
});
export const GalleryWithFetchPriority = React.memo(function Gallery({
  isPriorityCard
}: {
  isPriorityCard: boolean;
}) {
  const {
    hotelId
  } = useContext(HotelCardContext);
  const hotel = useSelector(state => getHotel(state, hotelId));
  const {
    brandMainHotelImageIndex
  } = useBrand();
  if (!hotel) return <GalleryLoading />;
  const primaryImage = hotel.imageURIs?.[brandMainHotelImageIndex || 0] ?? '';
  const dpr = getDevicePixelRatio(window);
  const extraProcessingParams = {
    dpr
  };
  return <Box display="flex" flexDirection="column" minHeight="100%" height="100%" width={`${toggle('2a3185b4-mobile-hotel-card-no-offers', GALLERY_WIDTH, GALLERY_WIDTH_EXPERIMENTAL)}px`} overflow="hidden">
      <Box data-id={SelectedElement.Image} display="flex" flexDirection="column" flex="1" position="relative" justifyContent="center">
        <Box position="absolute" width="100%" height="100%" transition={isPriorityCard ? '' : 'opacity 500ms ease-in-out'}>
          <GalleryImage>
            {primaryImage ?
          // eslint-disable-next-line @next/next/no-img-element
          <img src={imageProvider(primaryImage, SIZES['mobileLarge'], extraProcessingParams)} alt="" width={toggle('2a3185b4-mobile-hotel-card-no-offers', GALLERY_WIDTH, GALLERY_WIDTH_EXPERIMENTAL)} height={LAZYLOAD_PLACEHOLDER_HEIGHT} loading={isPriorityCard ? 'eager' : 'lazy'}
          // eslint-disable-next-line react/no-unknown-property
          fetchPriority={isPriorityCard ? 'high' : 'auto'} data-id={`HotelCardMobileImage-${hotelId}`} /> : <Image url={placeHolderImage} />}
          </GalleryImage>
        </Box>
      </Box>
    </Box>;
});

require("./GalleryWithFetchPriority.wyw-in-js.css!=!../../../../../../node_modules/@wyw-in-js/webpack-loader/lib/outputCssLoader.js?cacheProvider=!./GalleryWithFetchPriority.tsx");